import { memo, useRef, useState } from 'react';
import { CheckIcon } from '@page/icons';

import { IconButton, IconButtonBaseProps } from '../../designSystem/IconButton';

interface CopyIconButtonProps extends IconButtonBaseProps {
  value?: string;
  copiedTooltip?: string;
  timeout?: number;
  onClick?: (event: React.MouseEvent) => void;
}

const CopyIconButtonBase = ({
  value,
  children,
  tooltip = 'Copy',
  copiedTooltip = 'Copied',
  timeout = 2000,
  onClick,
  ...rest
}: CopyIconButtonProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const timeoutRef = useRef<number | null>(null);

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();

    setIsCopied(true);

    if (value) {
      navigator.clipboard.writeText(value);
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = window.setTimeout(() => {
      setIsCopied(false);
    }, timeout);

    onClick?.(event);
  };

  const displayIcon = isCopied ? <CheckIcon className="size-5 fill-icon-success text-icon-success" /> : children;
  const displayTooltip = isCopied ? copiedTooltip : tooltip;

  return (
    <IconButton onClick={handleClick} tooltip={displayTooltip} {...rest}>
      {displayIcon}
    </IconButton>
  );
};

export const CopyIconButton = memo(CopyIconButtonBase);
